var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#F86B34"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2658_26854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2658_26854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8691 23.7372L19.5182 19.3866C20.6322 18.125 21.3167 16.472 21.3167 14.6579C21.3167 10.7121 18.1044 7.5 14.1584 7.5C10.2123 7.5 7 10.7121 7 14.6579C7 18.6037 10.2123 21.8158 14.1584 21.8158C15.9703 21.8158 17.6235 21.1336 18.8874 20.0174L23.2383 24.368C23.3255 24.4553 23.4396 24.5 23.5537 24.5C23.6678 24.5 23.7819 24.4553 23.8691 24.368C24.0436 24.1936 24.0436 23.9095 23.8691 23.735V23.7372ZM14.1584 20.9211C10.7045 20.9211 7.8948 18.1116 7.8948 14.6579C7.8948 11.2042 10.7045 8.39474 14.1584 8.39474C17.6123 8.39474 20.4219 11.2042 20.4219 14.6579C20.4219 18.1116 17.6123 20.9211 14.1584 20.9211Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6bb271c61d4009218a313c89667ae3cd.svg";
export { ForwardRef as ReactComponent };